<template>
  <el-dialog
    v-if="dialogAddMember"
    class="dialogAddMember"
    width="800px"
    top="40px"
    :visible.sync="dialogAddMember"
    :close-on-click-modal="false"
    append-to-body
    destroy-on-close
    @close="closeDialog">
    <div
      slot="title"
      class="d-flex align-items-center justify-content-between py-3 px-12 border-bottom">
      <span class="fw-700 text-grey900 font-16">Thêm thành viên</span>
      <div
        class="d-flex align-items-center me-4 bg-blue100 py-1 px-2 rounded"
        style="border: thin solid #c2dcff">
        <img
          class="rounded-circle"
          style="width: 24px; height: 24px"
          :src="conversation?.avatar || '/assets/images/no-avatar.png'" />
        <span
          class="font-14 fw-500 me-1 trim-text-1-line ms-2"
          style="max-width: 250px">
          {{ conversation.swName && conversation.swName.length > 0 ? conversation.swName : conversation.toName }}
        </span>
      </div>
    </div>
    <div class="d-flex flex-column">
      <div class="d-flex border-bottom align-items-center">
        <el-input
          class="py-2 mx-12"
          v-model="searchKey"
          size="medium"
          @input="searchContact()"
          placeholder="Tìm kiếm">
          <IconV2
            slot="prefix"
            class="mt-3 ms-1"
            name="v2-search" />
        </el-input>
        <el-popover
          placement="bottom"
          trigger="click">
          <div class="conversation-box-popover">
            <div class="d-flex align-items-center flex-grow-1 my-1">
              <div
                class="radio-button me-3"
                :class="tagType === 0 && 'radio-button-active'"
                @click="changeTagOpt(0)">
                <span>Tất cả ({{ getTagCount(0) }})</span>
              </div>
              <div
                class="radio-button me-3"
                :class="tagType === 1 && 'radio-button-active'"
                @click="changeTagOpt(1)">
                <span>Thẻ chỉ định ({{ getTagCount(1) }})</span>
              </div>
              <div
                class="radio-button"
                :class="tagType === 2 && 'radio-button-active'"
                @click="changeTagOpt(2)">
                <span>Thẻ thường ({{ getTagCount(2) }})</span>
              </div>
            </div>
            <el-input
              class="ms-1"
              placeholder="Tìm kiếm thẻ đã tạo"
              v-model="searchTagName"
              size="small"></el-input>
            <div
              class="d-flex flex-wrap text-center overflow-auto mt-2 px-1"
              style="max-width: 500px; max-height: 400px; min-width: 500px">
              <div
                v-for="(item, index) in listTagView"
                :key="index">
                <div
                  class="d-flex pointer"
                  @click="addOrRemoveTag(item)">
                  <TagV2
                    :data="item"
                    :inactive="!isSelected(item)"
                    :item="item"
                    :selected="isSelected(item)"
                    :is-button="true" />
                </div>
              </div>
            </div>
          </div>

          <el-tooltip
            slot="reference"
            effect="dark"
            content="Lọc theo tag"
            placement="top">
            <el-button
              size="small"
              class="d-flex text-blue500 me-3">
              <div class="d-flex">
                <span>Lọc theo thẻ đã gắn ({{ selectedTags.length }})</span>
                <IconV2
                  name="v2-arrow1_drop_down"
                  color="#1769D7" />
              </div>
            </el-button>
          </el-tooltip>
        </el-popover>
      </div>
      <div class="">
        <div
          class="d-flex"
          style="min-height: 300px">
          <div class="flex-1 border-right">
            <div class="add-group-contact-scr">
              <div
                v-for="(itemGroup, index) in contactView"
                :key="index">
                <div class="font-14 text-grey600 py-1 px-12 border-bottom border-top bg-base-milk d-flex justify-content-between">
                  <span class="fw-700">{{ itemGroup[0].displayName.charAt(0) }}</span>
                  <span>{{ itemGroup.length }}</span>
                </div>
                <div
                  v-for="contact in itemGroup"
                  :key="contact.id"
                  class="d-flex align-items-center py-2 px-12">
                  <el-checkbox
                    :value="checkSelectedContact(contact.uid)"
                    @change="selectItem(contact)" />
                  <el-avatar
                    :size="48"
                    :src="contact.avatar"
                    class="mx-2 mb-1" />
                  <div class="d-flex flex-column justify-content-between">
                    <div
                      style="white-space: normal"
                      class="flex-1 font-size-14 text-1-line text-grey900 fw-700">
                      {{ contact.displayName }}
                      <span
                        v-if="contact.swName"
                        class="font-14 text-grey600 fw-400">
                        | {{ contact.swName }}
                      </span>
                    </div>
                    <ListTagEllipsis
                      v-if="contact.tags.length"
                      class="ms-0 mt-1 mb-0"
                      :tags="contact.tags || []" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex-1 px-2">
            <div class="font-size-14 text-grey700 fw-bold mt-1 px-1 d-flex align-items-center justify-content-between">
              <span>Tài khoản đã chọn ({{ items.length }})</span>
              <div
                class="me pointer"
                @click="removeAllItems">
                <IconV2
                  name="v2-delete_sweep"
                  size="20px" />
              </div>
            </div>
            <div
              v-if="!items.length"
              class="d-flex flex-column flex-grow-1 align-items-center justify-content-center h-100">
              <img src="/assets/images/empty_account.svg" />
              <span class="font-14 text-grey600 mt-2">Chưa có tài khoản nào được chọn</span>
            </div>
            <div
              v-else
              class="add-group-con-scr">
              <div
                class="mt-2 mx-1 rounded-2 d-flex align-items-center justify-content-between"
                style="background-color: rgba(225, 237, 253, 0.6); color: #42444d; width: 300 px; border: thin solid #c2dcff"
                v-for="(contact, index) in items"
                :key="index">
                <div
                  class="position-relative rounded-2 d-flex pointer d-flex align-items-center flex-grow-1 py-1"
                  @click.stop.prevent="unSelect(contact.uid)">
                  <el-image
                    :src="contact.avatar"
                    class="ms-1 me-2 img-selected">
                    <div
                      slot="error"
                      class="image-slot">
                      <el-image
                        src="/assets/images/no-avatar.png"
                        class="img-selected"></el-image>
                    </div>
                  </el-image>
                  <div>
                    <div
                      style="white-space: normal"
                      class="text-1-line font-size-14 text-break me-1">
                      <span>{{ contact.displayName }}</span>
                    </div>
                    <div
                      style="white-space: normal"
                      class="text-1-line font-13 text-grey600 text-break me-1">
                      <span>{{ contact.swName }}</span>
                    </div>
                  </div>
                </div>
                <div
                  class="me-2 pointer"
                  @click.stop.prevent="unSelect(contact.uid)">
                  <IconV2 name="v2-close" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="divider-custom" />
        <div class="d-flex justify-content-end px-12 py-2">
          <el-button
            size="md"
            @click="closeDialog()">
            Hủy
          </el-button>
          <el-button
            type="primary"
            size="md"
            :disabled="!items.length"
            @click="add()">
            Thêm thành viên
          </el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { groupByName } from "../../lib/text-utils";
import ListTagEllipsis from "../ListTagEllipsis.vue";
import { removeVietnameseTones } from "../../lib/text-utils";
import TagV2 from "../TagV2.vue";

export default {
  name: "DialogAddMember",
  props: ["dialogAddMember", "conversation", "members"],
  components: { ListTagEllipsis, TagV2 },
  data() {
    return {
      searchKey: "",
      contactView: [],
      items: [],
      searchTagName: "",
      tagType: 0,
      selectedTags: [],
    };
  },
  computed: {
    listTagView() {
      let view = [];
      switch (this.tagType) {
        case 0: {
          view = this.app.tags;
          break;
        }
        case 1: {
          view = this.app.tags.filter((p) => p.assign);
          break;
        }
        case 2: {
          view = this.app.tags.filter((p) => !p.assign);
          break;
        }
      }

      if (this.searchTagName) {
        view = view.filter(
          (tag) =>
            removeVietnameseTones(tag.name.toLowerCase()).includes(this.searchTagName.toLowerCase()) ||
            tag.name.toLowerCase().includes(this.searchTagName.toLowerCase())
        );
      }

      return view;
    },

  },

  methods: {
    addOrRemoveTag(tag) {
      const index = this.selectedTags.indexOf(tag.id);
      if (index > -1) {
        this.selectedTags.splice(index, 1);
      } else {
        this.selectedTags.push(tag.id);
      }
      this.getContacts();
    },
    isSelected(tag) {
      let index = this.selectedTags.indexOf(tag.id);
      return index > -1;
    },
    getTagCount(valueOption) {
      switch (valueOption) {
        case 0: {
          return this.app.tags.length;
        }
        case 2: {
          return this.app.tags.filter((t) => !t.assign).length;
        }
        case 1: {
          return this.app.tags.filter((t) => t.assign).length;
        }
        default:
          return 0;
      }
    },
    changeTagOpt(tagType) {
      this.tagType = tagType;
    },
    removeAllItems() {
      this.items = [];
    },

    closeDialog() {
      this.$bus.$emit("closeDialogMember");
      this.$emit("close");
    },

    getContacts() {
      this.$http
        .post("/api/contact/filter", {
          searchKey: "",
          accountId: this.conversation.accountId,
          selectedTags: this.selectedTags,
        })
        .then((resp) => {
          this.contactList = resp.data
            .map((c) => ({
              ...c,
              ...c.contact,
              tags: c.tags,
            }))
            .filter((s) => !this.members.map((s) => s.id).includes(s.uid));
          this.searchContact();
        });
    },
    add() {
      let membersId = this.items.map((p) => {
        return p.uid;
      });
      if (membersId.length === 0) {
        return this.alert("error", "Bạn chưa chọn thành viên");
      }
      let body = {
        groupId: this.conversation.toId,
        accountId: this.conversation.accountId,
        membersId: membersId,
      };
      this.$http.post("/api/conversation/inviteMembers", body).then((resp) => {
        if (resp.data.error_message === "Successful.") {
          this.alert("success", "Thêm thành công");
          this.$emit("addMembers");
        } else {
          this.alert("error", "Xin thử lại");
        }
        this.closeDialog();
      });
    },
    searchContact() {
      if (this.searchKey.length > 0) {
        let key = this.searchKey.toLowerCase();
        let keyNoTone = removeVietnameseTones(key);
        this.contactView = groupByName(
          this.contactList.filter((p) => this.matchContact(p, key, keyNoTone)),
          "displayName"
        );
      } else {
        this.contactView = groupByName(this.contactList, "displayName");
      }
    },
    // /api/contact/filter trả cả swName (tên trên Salework) nên tìm theo cả 2, không chỉ displayName.
    // So cả bản có dấu lẫn bản bỏ dấu để gõ "dao quan tu" vẫn ra "Đạo Quân Tử".
    matchContact(contact, key, keyNoTone) {
      return [contact.displayName, contact.swName].some((value) => {
        if (!value) return false;
        let text = String(value).toLowerCase();
        if (text.includes(key)) return true;
        return Boolean(keyNoTone) && removeVietnameseTones(text).includes(keyNoTone);
      });
    },
    selectItem(contact) {
      let filter = this.items.filter((con) => con.uid == contact.uid);
      if (filter != null && filter.length > 0) {
        const index = this.items.indexOf(filter[0]);
        if (index > -1) {
          this.items.splice(index, 1);
        }
      } else {
        this.items.push(contact);
      }
    },
    unSelect(contactId) {
      let filter = this.items.filter((con) => con.uid == contactId);
      if (filter != null && filter.length > 0) {
        const index = this.items.indexOf(filter[0]);
        if (index > -1) {
          this.items.splice(index, 1);
        }
      }
    },
    checkSelectedContact(id) {
      let filter = this.items.filter((con) => con.uid == id);
      return filter != null && filter.length > 0;
    },
    listAddMember() {
      return this.contactList.filter((s) => !this.members.map((s) => s.id).includes(s.uid));
    },
  },
  created() {
    this.getContacts();
  },
};
</script>

<style lang="scss" >
.dialogAddMember {
  .el-dialog__body {
    padding: 0 !important;
  }
  .el-dialog__header {
    padding: 0 !important;
  }
  .img-selected {
    border: 1px solid #fff;
    width: 36px;
    height: 36px;
    min-width: 36px;
    min-height: 36px;
    border-radius: 18px;
  }
}
</style>